"use client";

import React, { ReactNode } from "react";
import { useSplitPosition } from "./useSplitPosition";
import SplitHandle from "./SplitHandle";

interface ResizableSplitProps {
    left: ReactNode;
    right: ReactNode;
    defaultPercent?: number;
    minPercent?: number;
    maxPercent?: number;
    storageKey?: string;
    leftLabel?: string;
    rightLabel?: string;
    className?: string;
}

export default function ResizableSplit({
    left,
    right,
    defaultPercent = 50,
    minPercent = 25,
    maxPercent = 75,
    storageKey,
    leftLabel = "left panel",
    rightLabel = "right panel",
    className = "",
}: ResizableSplitProps) {
    const { containerRef, percent, isDesktop, isDragging, startDrag, handleKeyDown, resetToDefault } =
        useSplitPosition({ defaultPercent, minPercent, maxPercent, storageKey });

    return (
        <div ref={containerRef} className={`w-full flex flex-col md:flex-row gap-4 md:gap-0 items-stretch ${className}`}>
            <div className="w-full min-w-0" style={isDesktop ? { width: `${percent}%` } : undefined}>
                {left}
            </div>
            <SplitHandle
                onMouseDown={startDrag}
                onTouchStart={startDrag}
                onKeyDown={handleKeyDown}
                onDoubleClick={resetToDefault}
                ariaLabel={`Resize ${leftLabel} and ${rightLabel}`}
                percent={percent}
                isDragging={isDragging}
            />
            <div className="w-full min-w-0" style={isDesktop ? { width: `${100 - percent}%` } : undefined}>
                {right}
            </div>
        </div>
    );
}
